import {
  Directive,
  ElementRef,
  Inject,
  Input,
  OnChanges,
  OnInit,
} from '@angular/core';
import { updateElementStyles } from '../utils/style.utils';
import { Theme, THEME_TOKEN } from '../types/theme.types';
import {
  ButtonProps,
  buttonStylesSAG,
  buttonStylesSHS,
} from './button.styles';
import { componentStylesByTheme } from '../utils/theme.utils';

@Directive({
  selector: 'button[sag-ui-button]',
})
export class ButtonDirective implements OnInit, OnChanges {
  @Input() color?: ButtonProps['color'];

  constructor(
    @Inject(THEME_TOKEN) private readonly theme: Theme,
    private readonly elementRef: ElementRef<HTMLButtonElement>
  ) {}

  ngOnChanges(): void {
    this.applyStyling();
  }

  ngOnInit(): void {
    this.applyStyling();
  }

  private applyStyling() {
    const buttonStyles = componentStylesByTheme(
      this.theme,
      buttonStylesSAG,
      buttonStylesSHS
    );

    updateElementStyles(this.elementRef, buttonStyles({ color: this.color }));
  }
}
